/** Bump when consent copy or terms change - users must re-accept. */
export const LEARNING_CONSENT_VERSION = 'v1';

/** Syllabus pillars shown in the consent modal (aligned with Jyotisha roadmap). */
export const JYOTISHA_LEARNING_PILLARS = [
  {
    id: 'introduction',
    en: 'Core language of Jyotisha - branches, kundali types, fixed rules',
    hi: 'ज्योतिष की मूल भाषा - शाखाएँ, कुंडली प्रकार, नियम',
  },
  {
    id: 'rashis',
    en: 'Twelve rashis as temperament and life-stage',
    hi: 'बारह राशियाँ - स्वभाव और जीवन-मंच',
  },
  {
    id: 'bhava-cosmos',
    en: 'Bhavas (houses) as karmic life-areas',
    hi: 'भाव - कर्म के जीवन-क्षेत्र',
  },
  {
    id: 'nakshatra',
    en: 'Twenty-seven nakshatras, dasha anchors, tara',
    hi: '२७ नक्षत्र, दशा आधार, तारा',
  },
  {
    id: 'planets',
    en: 'Grahas - dignity, drishti, friendship, transits',
    hi: 'ग्रह - उच्च-नीच, दृष्टि, मैत्री, गोचर',
  },
  {
    id: 'panchang',
    en: 'Panchang - tithi, yoga, karana, muhurta basics',
    hi: 'पंचांग - तिथि, योग, करण, मुहूर्त',
  },
  {
    id: 'reading-charts',
    en: 'Reading charts - lagna, vargas, dasha, gochar judgment',
    hi: 'चार्ट पठन - लग्न, वर्ग, दशा, गोचर',
  },
  {
    id: 'calculators',
    en: 'Interactive calculators to practise on your own chart',
    hi: 'अपनी कुंडली पर अभ्यास - इंटरैक्टिव कैलकुलेटर',
  },
];

export const LEARNING_CONSENT_COPY = {
  titleEn: 'Before you continue',
  titleHi: 'आगे बढ़ने से पहले',
  subtitleEn: 'Takshify Jyotisha is a beginner learning space - not a fortune-telling service.',
  subtitleHi: 'Takshify ज्योतिष शुरुआती सीखने का स्थान है - भविष्यवाणी सेवा नहीं।',
  predictionEn:
    'Classical Jyotisha is a science of prediction and timing - it shows tendencies, karma, and auspicious windows. It is not deterministic fate. Free will, effort, remedies, and the full chart (grahas, bhavas, dasha, gochar) all matter.',
  predictionHi:
    'शास्त्रीय ज्योतिष भविष्य और समय की विज्ञान है - प्रवृत्ति, कर्म और शुभ अवसर दिखाता है; यह अटल भाग्य नहीं। स्वेच्छा, प्रयास, उपाय और पूरी कुंडली (ग्रह, भाव, दशा, गोचर) सब महत्वपूर्ण हैं।',
  cautionEn:
    'Use this website with caution. Simplified lessons and calculators are teaching tools. For important life decisions - marriage, health, finance, travel - confirm with the full horoscope and a qualified jyotishi.',
  cautionHi:
    'इस वेबसाइट की सामग्री सावधानी से उपयोग करें। सरलीकृत पाठ और कैलकुलेटर शिक्षण उपकरण हैं। विवाह, स्वास्थ्य, वित्त या यात्रा जैसे बड़े निर्णय पूरी कुंडली और अनुभवी ज्योतिषी से पुष्टि करें।',
  purposeEn:
    'You are here to learn basics while exploring interactive charts - rashis, nakshatras, grahas, bhavas, panchang, dasha, and more - not to receive personal predictions from this site.',
  purposeHi:
    'आप यहाँ मूल बातें सीखने और इंटरैक्टिव चार्ट (राशि, नक्षत्र, ग्रह, भाव, पंचांग, दशा आदि) से खेलकर समझने आए हैं - इस साइट से व्यक्तिगत भविष्यवाणी पाने के लिए नहीं।',
  ethicsEn:
    'Astrology should guide and clarify - not spread fear, dependency, or deception. It supports dharma, artha, kama, and moksha when used ethically.',
  ethicsHi:
    'ज्योतिष मार्गदर्शन और स्पष्टता दे - भय, अंधविश्वास या धोखे के लिए नहीं। नैतिक उपयोग से धर्म, अर्थ, काम और मोक्ष में सहायता होती है।',
  checkboxEn: 'I understand Jyotisha here is for learning basics, not deterministic prediction, and I will use the content responsibly.',
  checkboxHi:
    'मैं समझता/समझती हूँ कि यहाँ ज्योतिष मूल सीखने के लिए है, अटल भविष्यवाणी के लिए नहीं, और मैं सामग्री का जिम्मेदारी से उपयोग करूँगा/करूँगी।',
  acceptEn: 'I agree - continue learning',
  acceptHi: 'मैं सहमत हूँ - सीखना जारी रखें',
  signOutEn: 'Sign out instead',
  signOutHi: 'साइन आउट करें',
};
